// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"215":"bbd8ed1e","787":"92cc9306"}[chunkId] + ".chunk.js";
};